import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiService } from '../../services/apiService';

export const uploadFile = createAsyncThunk(
    'dashboard/uploadFile',
    async ({ file, uploadType }, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('upload_type', uploadType);

            const response = await apiService.uploadCsv(formData);

            return response;
        } catch (error) {
            return rejectWithValue(error || 'Upload failed');
        }
    }
);

export const proceedFile = createAsyncThunk(
    'dashboard/proceedFile',
    async ({ file_path, uploadType }, { rejectWithValue }) => {
        try {

            const formData = new FormData();
            formData.append('file_path', file_path);
            formData.append('upload_type', uploadType);

            const response = await apiService.proceedCsv(formData);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Proceed failed');
        }
    }
);

const initialState = {
    uploadLoading: false,
    uploadError: null,
    uploadedFiles: null,
};

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        clearUploadError: (state) => {
            state.uploadError = null;
        },
        resetUploadData: (state) => {
            state.uploadLoading = false;
            state.uploadError = null;
            state.uploadedFiles = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(uploadFile.pending, (state) => {
                state.uploadLoading = true;
                state.uploadError = null;
            })
            .addCase(uploadFile.fulfilled, (state, action) => {
                state.uploadLoading = false;
                state.uploadedFiles = action.payload;
                state.uploadError = null;
            })
            .addCase(uploadFile.rejected, (state, action) => {
                state.uploadLoading = false;
                state.uploadError = action.payload;
            })
            .addCase(proceedFile.pending, (state) => {
                state.uploadLoading = true;
                state.uploadError = null;
            })
            .addCase(proceedFile.fulfilled, (state, action) => {
                state.uploadLoading = false;
                state.uploadedFiles = action.payload;
                state.uploadError = null;
            })
            .addCase(proceedFile.rejected, (state, action) => {
                state.uploadLoading = false;
                state.uploadError = action.payload;
            });
    },
});

export const { clearUploadError, resetUploadData } = dashboardSlice.actions;

export default dashboardSlice.reducer;